import { Component, input, InputSignal } from '@angular/core';
import { Balance } from 'src/app/models/balance.model';

@Component({
  selector: 'app-event-balances-table',
  templateUrl: './event-balances-table.component.html',
  styleUrl: './event-balances-table.component.scss',
  standalone: false,
})
export class EventBalancesTableComponent {
  balances: InputSignal<Balance[]> = input.required<Balance[]>();

  protected displayedColumns: string[] = [
    'event',
    'shoutoutCount',
    'grossRevenue',
    'netRevenue',
    'actions',
  ];
}
